(() => {
const root=document.querySelector('[data-landing]');if(!root)return;
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
const range=document.querySelector('#order-range');
function updatePrice(){const n=Number(range.value);const price=n<=50?0:n<=200?34.99:n<=500?44.99:n<=1000?54.99:n<=2000?99.99:159.99;document.querySelector('#order-count').textContent=n.toLocaleString()+(n===2500?'+':'');document.querySelector('#price-value').textContent=price===0?'$0':'$'+price.toFixed(2);document.querySelector('#price-tier').textContent=n<=50?'Your first 50 orders are on us.':n<=200?'51–200 Cartivate orders per month.':n<=500?'201–500 Cartivate orders per month.':n<=1000?'501–1,000 Cartivate orders per month.':n<=2000?'1,001–2,000 Cartivate orders per month.':'2,001+ Cartivate orders per month.';range.setAttribute('aria-valuetext',n.toLocaleString()+' orders, $'+price+' per month');}
range.addEventListener('input',updatePrice);updatePrice();
// A brief invitation when the demo enters view; motion never runs indefinitely.
const demoAddButton = document.querySelector('[data-demo-add]');
if (demoAddButton && 'IntersectionObserver' in window) {
  const demoInviteObserver = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    if (!reduced.matches) {
      demoAddButton.classList.add('is-inviting');
      window.setTimeout(() => demoAddButton.classList.remove('is-inviting'), 4900);
    }
    demoInviteObserver.disconnect();
  }, { threshold: 0.65 });
  demoInviteObserver.observe(demoAddButton);
  demoAddButton.addEventListener('click', () => demoAddButton.classList.remove('is-inviting'));
}

const productForm=document.querySelector('.cv-product-card__form');
if(productForm){
  const button=productForm.querySelector('[data-demo-add]');let submitting=false,timer;
  const restore=()=>{submitting=false;button.removeAttribute('aria-busy');clearTimeout(timer)};
  productForm.addEventListener('submit',event=>{if(submitting){event.preventDefault();return}submitting=true;button.setAttribute('aria-busy','true');timer=setTimeout(restore,4000)});
  window.addEventListener('AppCartAddToCartComplete',restore);
}
document.querySelectorAll('a[href="#store-preview-form"]').forEach(link=>link.addEventListener('click',()=>requestAnimationFrame(()=>document.querySelector('[data-cvt-form] input[name="url"]').focus({preventScroll:true}))));
})();
